<template>
  <div class="box">
    <div class="box-header d-flex align-center justify-content-between">
      <h4 class="box-title">
        <i class="icofont-listine-dots"></i> Resultado atual

        <div class="resultado-toggle ml-3">
          <button
            type="button"
            class="resultado-toggle-btn"
            :class="{ active: tipoResultado === 'quadrimestral' }"
            @click="$emit('changeTipoResultado', 'quadrimestral')"
          >
            Quadrimestre
          </button>
          <button
            type="button"
            class="resultado-toggle-btn"
            :class="{ active: tipoResultado === 'mensal' }"
            @click="$emit('changeTipoResultado', 'mensal')"
            :disabled="!podeAlternarResultado"
          >
            Mês
          </button>
        </div>
      </h4>
      <button class="btn btn-simulador" @click="abrirSimulador">
        Simulador
      </button>
    </div>
    <div class="box-body">
      <table
        class="table table-responsive table-bordered text-center table2"
        id="table"
      >
        <thead>
          <tr>
            <th>Por</th>
            <th>
              Numerador
              <span
                v-b-tooltip.hover
                title="Somatório da(s) boa(s) prática(s) pontuada(s) durante o acompanhamento do desenvolvimento infantil."
                class="icon-tooltip"
              >
                <i class="icofont-info-circle"></i>
              </span>
            </th>
            <th>
              Denominador
              <span
                v-b-tooltip.hover
                title="Total de crianças com idade igual a 2 (dois) anos completos."
                class="icon-tooltip"
              >
                <i class="icofont-info-circle"></i>
              </span>
            </th>
            <th>
              {{ tipoResultado == 'quadrimestral' ? 'Média' : 'Pontuação' }}
              <span
                v-b-tooltip.hover
                :title="
                  tipoResultado == 'quadrimestral'
                    ? 'Média dos resultados das pontuações no indicador acumulado no quadrimestre até o mês atual.'
                    : 'Numerador / Denominador * 100'
                "
                class="icon-tooltip"
              >
                <i class="icofont-info-circle"></i>
              </span>
            </th>
            <th>
              Classificação
              <!-- <span
                v-b-tooltip.html.hover
                :title="tooltipClassificacao"
                class="icon-tooltip"
              >
                <i class="icofont-info-circle"></i>
              </span> -->
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ $store.state.cidade }}</td>
            <td class="text-center font-weight-bold">
              <loader :value="municipio.numerador" :loading="loading"></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader
                :value="municipio.denominador"
                :loading="loading"
              ></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader
                :value="municipio.resultado"
                :loading="loading"
                :isPercentage="tipoResultado == 'quadrimestral' ? false : true"
              ></loader>
            </td>
            <td
              :class="getColorClassificacao(municipio.classificacao)"
              class="font-weight-bold"
            >
              <TextoClassificacaoIndicador
                :loading="loading"
                :classificacao="municipio.classificacao"
                :idIndicador="51"
                :resultado="municipio.resultado"
              />
            </td>
          </tr>
          <tr v-if="selectedEquipe != ''">
            <td>{{ selectedEquipe != '' ? selectedEquipe.no_equipe : '-' }}</td>
            <td class="text-center font-weight-bold">
              <loader :value="equipe.numerador" :loading="loading"></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader :value="equipe.denominador" :loading="loading"></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader
                :value="equipe.resultado"
                :loading="loading"
                :isPercentage="tipoResultado == 'quadrimestral' ? false : true"
              ></loader>
            </td>
            <td
              :class="getColorClassificacao(equipe.classificacao)"
              class="font-weight-bold"
            >
              <TextoClassificacaoIndicador
                :loading="loading"
                :classificacao="equipe.classificacao"
                :idIndicador="51"
                :resultado="equipe.resultado"
              />
            </td>
          </tr>
          <tr v-if="selectedMicroArea != ''">
            <td>
              {{
                selectedMicroArea != '' ? 'MICROÁREA ' + selectedMicroArea : '-'
              }}
            </td>
            <td class="text-center font-weight-bold">
              <loader :value="micro_area.numerador" :loading="loading"></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader
                :value="micro_area.denominador"
                :loading="loading"
              ></loader>
            </td>
            <td class="text-center font-weight-bold">
              <loader
                :value="micro_area.resultado"
                :loading="loading"
                :isPercentage="tipoResultado == 'quadrimestral' ? false : true"
              ></loader>
            </td>
            <td
              :class="getColorClassificacao(micro_area.classificacao)"
              class="font-weight-bold"
            >
              <TextoClassificacaoIndicador
                :loading="loading"
                :classificacao="micro_area.classificacao"
                :idIndicador="51"
                :resultado="micro_area.resultado"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <FonteSincronizadorC />
    </div>
    <SimuladorModal
      ref="simulador"
      modal-id="simulador-modal"
      :dadosPercentualMunicipio="municipio"
      :dadosPercentualEquipe="equipe"
      :dadosPercentualMicroArea="micro_area"
      :selectedEquipe="selectedEquipe"
      :selectedMicroArea="selectedMicroArea"
    />
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import TextoClassificacaoIndicador from '@/components/utils/TextoClassificacaoIndicador'
import SimuladorModal from './SimuladorModal.vue'

export default {
  components: {
    Loader,
    TextoClassificacaoIndicador,
    SimuladorModal,
  },
  props: {
    disabledSelectResultado: {
      type: Boolean,
      default: false,
    },
    resetarSelectTabelaResultado: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    municipio: {
      type: Object,
      default: () => {},
    },
    equipe: {
      type: Object,
      default: () => {},
    },
    acs: {
      type: Object,
      default: () => {},
    },
    micro_area: {
      type: Object,
      default: () => {},
    },
    selectedEquipe: {
      type: [Object, String],
      default: '',
    },
    selectedMicroArea: {
      type: [String],
      default: '',
    },
    selectedFilterBoasPraticas: {
      type: Object,
      default: () => null,
    },
    tipoResultado: {
      type: String,
      default: 'quadrimestral',
    },
  },
  data() {
    return {}
  },
  mounted() {},
  watch: {},
  computed: {
    tituloTabela() {
      return this.selectedFilterBoasPraticas == null ||
        this.selectedFilterBoasPraticas.value == null
        ? 'Todas'
        : this.selectedFilterBoasPraticas.label
    },

    podeAlternarResultado() {
      return (
        this.selectedFilterBoasPraticas == null ||
        this.selectedFilterBoasPraticas.value == null
      )
    },

    tooltipClassificacao() {
      return [
        'Regular: <= 25',
        'Suficiente: > 25 e <= 50',
        'Bom: > 50 e <= 75',
        'Ótimo: > 75 e <= 100',
      ].join('<br>')
    },
  },
  methods: {
    /**
     * Altera o tipo de resultado para mensal somente quando o filtro for "Todas".
     *
     * @returns {void}
     */
    alterarParaMensal() {
      if (!this.podeAlternarResultado) {
        return
      }

      this.$emit('changeTipoResultado', 'mensal')
    },

    /**
     * Retorna a cor associada à classificação do indicador.
     * @param {String} classificacao Classificação do resultado
     * @returns {String} Cor correspondente
     */
    getColorClassificacao(classificacao) {
      switch (classificacao) {
        case 'Ótimo':
          return 'blue'
        case 'Bom':
          return 'green'
        case 'Suficiente':
          return 'orange'
        case 'Regular':
          return 'red'
        default:
          break
      }
    },

    /**
     * Abre o simulador
     */
    /**
     * Abre o simulador apenas quando o filtro Mês estiver selecionado.
     */
    abrirSimulador() {
      if (this.tipoResultado !== 'mensal') {
        this.$toast.warning(
          'Selecione o filtro Mês para visualizar o simulador',
          'Atenção:',
          {
            position: 'topRight',
            backgroundColor: '#FFA94D',
          }
        )
        return
      }

      this.$refs.simulador.open()
    },
  },
}
</script>

<style lang="scss" src="../../styles.scss" scoped></style>
